/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable max-len */
/* eslint-disable no-restricted-globals */
/* eslint-disable */
// ==============================================
// ==================Import======================
// ==============================================

// ===================Dependancies================
import { useDispatch, useSelector } from 'react-redux';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';

// =================Librairie Joyride===================
import Joyride, { STATUS } from 'react-joyride';

// =================MUI===================
import { Button } from '@mui/material';

// =================Composants===================

import SliderRadius from './SliderRadius';
// const AdvancedSearch = lazy(() => import('./AdvancedSearch'))
import AdvancedSearch from './AdvancedSearch';
import NoApiResponse from './NoApiResponse';
// const MapLeaflet = lazy(() => import('./MapLeaflet'))
import MapLeaflet from './MapLeaflet';
// const Datagrid = lazy(() => import('./DataGrid'))
import DataGrid from './DataGrid';
import Spinner2 from '../Spinner2';


// ====================Action====================
import {
  toggleAdvancedSearch,
  setRadiusValue,
  setSaveRectangleNorth,
  setSaveRectangleSouth,
  setSaveRectangleEast,
  setSaveRectangleWest,
  setValueChange,
  setSaveCircleLat,
  setSaveCircleLon,
  setOpenTour,
  setOpenPopper,
  fetchReceiverList,
  fetchAntennaList,
  fetchRadomeList,
  fetchFileTypeList,
  setClearButton,
  exportCsv,
  fetchBackendPopup,
} from '../../actions/site';

// ==================Style&IMG===================
import './style.scss';
import { setFileNoData } from '../../actions/menuButton';
import ModalFileNoData from '../ModalFileNoData';
import { globalConfig } from '../../configuration/config';

function Site() {
// ================HOOK==========================
  const dispatch = useDispatch();
  const isOpen = useSelector((state) => state.site.advancedSearch.isOpen);
  const radius = useSelector((state) => state.site.useMap.circle.radius);
  const loadingMap = useSelector((state) => state.site.map.loadingMap);
  const dataAvailable = useSelector((state) => state.site.data.dataAvailable);
  const rectangleNorth = useSelector((state) => state.site.useMap.rectangle.North);
  const rectangleSouth = useSelector((state) => state.site.useMap.rectangle.South);
  const rectangleEast = useSelector((state) => state.site.useMap.rectangle.East);
  const rectangleWest = useSelector((state) => state.site.useMap.rectangle.West);
  const openTour = useSelector((state) => state.site.joyride.openTour);
  const circleLat = useSelector((state) => state.site.useMap.circle.lat);
  const circleLon = useSelector((state) => state.site.useMap.circle.lon);
  const polygon = useSelector((state) => state.site.useMap.polygon);

  const rowSelectedArray = useSelector(
    (state) => state.multipleMetadata.dataMultiple.markerSelectedArray,
  );
  const openPopper = useSelector((state) => state.site.popper.openPopper);
  const networkNameStation = useSelector((state) => state.site.popper.networkNameStation);
  const networkClicked = useSelector((state) => state.site.popper.networkClicked);
  const receiverTypeSelected = useSelector(
    (state) => state.site.advancedSearch.equipement.receiverType,
  );
  const antennaTypeSelected = useSelector(
    (state) => state.site.advancedSearch.equipement.antennaType,
  );
  const radomeTypeSelected = useSelector(
    (state) => state.site.advancedSearch.equipement.radomeType,
  );
  const satelliteSystemSelected = useSelector(
    (state) => state.site.advancedSearch.equipement.satelliteSystem,
  );
  const dateFromSelected = useSelector(
    (state) => state.site.advancedSearch.fileInfo.dateFrom,
  );
  const dateToSelected = useSelector(
    (state) => state.site.advancedSearch.fileInfo.dateTo,
  );
  const dataAvailabilitySelected = useSelector(
    (state) => state.site.advancedSearch.fileInfo.dataAvailability,
  );
  const dailyObservationSelected = useSelector(
    (state) => state.site.advancedSearch.fileInfo.dailyObservation,
  );
  const fileTypeSelected = useSelector(
    (state) => state.site.advancedSearch.fileInfo.fileType,
  );
  const fileStatusSelected = useSelector(
    (state) => state.site.advancedSearch.fileInfo.fileStatus,
  );
  const observationsTypeSelected = useSelector(
    (state) => state.site.advancedSearch.QCFileInfo.observationsTypes,
  );
  const frequenciesBandSelected = useSelector(
    (state) => state.site.advancedSearch.QCFileInfo.frequenciesBand,
  );
  const attributeChannelSelected = useSelector(
    (state) => state.site.advancedSearch.QCFileInfo.attributeChannel,
  );
  const satelliteSystemSelectedQC = useSelector(
    (state) => state.site.advancedSearch.QCFileInfo.satelliteSystem,
  );
  const epochSelected = useSelector(
    (state) => state.site.advancedSearch.QCFileInfo.epoch,
  );
  const elevationSelected = useSelector(
    (state) => state.site.advancedSearch.QCFileInfo.elevation,
  );
  const multipathSelected = useSelector(
    (state) => state.site.advancedSearch.QCFileInfo.multipath,
  );
  const cycleSelected = useSelector(
    (state) => state.site.advancedSearch.QCFileInfo.cycle,
  );
  const singlePointSelected = useSelector(
    (state) => state.site.advancedSearch.QCFileInfo.singlePoint,
  );
  const clockSelected = useSelector(
    (state) => state.site.advancedSearch.QCFileInfo.clock,
  );
  const loadingHeader = useSelector((state) => state.header.loadingHeader);
  const loadingFooter = useSelector((state) => state.footer.loadingFooter);
  const markerGridFilter = useSelector((state) => state.site.filter.marker);
  const siteNameGridFilter = useSelector((state) => state.site.filter.siteName);
  const greaterLatGridFilter = useSelector((state) => state.site.filter.greaterLat);
  const lessLatGridFilter = useSelector((state) => state.site.filter.lessLat);
  const greaterLonGridFilter = useSelector((state) => state.site.filter.greaterLon);
  const lessLonGridFilter = useSelector((state) => state.site.filter.lessLon);
  const greaterAltGridFilter = useSelector((state) => state.site.filter.greaterAlt);
  const lessAltGridFilter = useSelector((state) => state.site.filter.lessAlt);
  const greaterInstallDateGridFiletr = useSelector((state) => state.site.filter.greaterInstallDate);
  const lessInstallDateGridFilter = useSelector((state) => state.site.filter.lessInstallDate);
  const greaterEndDateGridFilter = useSelector((state) => state.site.filter.greaterEndDate);
  const lessEndDateGridFilter = useSelector((state) => state.site.filter.lessEndDate);
  const countryGridFilter = useSelector((state) => state.site.filter.country);
  const countryGridFilterQuery = useSelector((state) => state.site.filter.countryQuery);
  const stateGridFilter = useSelector((state) => state.site.filter.state);
  const cityGridFilter = useSelector((state) => state.site.filter.city);
  const agencyGridFilter = useSelector((state) => state.site.filter.agency);
  const networkGridFilter = useSelector((state) => state.site.filter.network);
  const invertedNetworkGridFilter = useSelector((state) => state.site.filter.invertedNetwork);
  const allPages = useSelector((state) => state.site.allPages);
  const newList = useSelector((state) => state.dataAPI.stations.newList);

  // Steps for Joyride
  const steps = [
    {
      target: '#mapid',
      content: <p><strong>Step 1: </strong>Select the stations on the map by clicking</p>,
      disableBeacon: true,
    },
    {
      target: '.leaflet-draw',
      content:
  <p>
    <strong>
      Step 2:
    </strong> Select the stations in area (polygon, rectangle, circle)
  </p>,
      disableBeacon: true,
    },
    {
      target: '#latlon',
      content:
  <p>
    <strong>Step3: </strong>
    Select the stations by coordinates
  </p>,
      disableBeacon: true,
    },
    {
      target: '.ag-header',
      content:
  <p>
    <strong>Step 4: </strong>
    Filter the stations by criteria
  </p>,
      disableBeacon: true,
    },
    {
      target: '.btn-show',
      content:
  <p>
    <strong>Step 5: </strong>
    Display advanced search panel
  </p>,
      disableBeacon: true,
    },
    {
      target: '.btn-metadata',
      content:
  <p>
    <strong>Step 6: </strong>
    Run the query for station metadata
  </p>,
      disableBeacon: true,
    },
    {
      target: '.btn-download',
      content:
  <p>
    <strong>Step 7: </strong>
    Run the query for files
  </p>,
      disableBeacon: true,
    },
    {
      target: '.btn-clear',
      content:
  <p>
    <strong>Step 8: </strong>
    Clear the selection and filter
  </p>,
      disableBeacon: true,
    },
  ];

  // When launching page initialized page with fetch of all data necessary to display the page
  useEffect(() => {
    dispatch(fetchReceiverList(globalConfig.config.REACT_APP_NODE_URL, globalConfig.config.REACT_APP_GLASS_API));
    dispatch(fetchAntennaList(globalConfig.config.REACT_APP_NODE_URL, globalConfig.config.REACT_APP_GLASS_API));
    dispatch(fetchRadomeList(globalConfig.config.REACT_APP_NODE_URL, globalConfig.config.REACT_APP_GLASS_API));
    dispatch(fetchFileTypeList(globalConfig.config.REACT_APP_NODE_URL, globalConfig.config.REACT_APP_GLASS_API));
    dispatch(setClearButton(false));
  }, []);

  useEffect(() => {
    if (allPages.length > 0) {
      for (let i = 0; i <= allPages.length - 1; i += 1) {
        if (allPages[i].meta.slug === 'alert-pop-up') {
          dispatch(fetchBackendPopup(allPages[i].id, globalConfig.config.REACT_APP_BACKEND_API));
        }
      }
    }
  }, [allPages]);

  // ================Handler=======================

  function handleToggleClick() {
    dispatch(toggleAdvancedSearch());
  }

  const handleCloseNetworkPopup = () => {
    dispatch(setOpenPopper(false));
  };

  // ===============Controlled fields circle===============

  function handleRadiusValue(event) {
    const { value } = event.target;
    if (!isNaN(value)) {
      dispatch(setRadiusValue(Number(value)));
    }
    if (value > 1500) {
      dispatch(setRadiusValue(1500));
    }
    dispatch(setValueChange(true));
  }

  function handleValueCircleLat(value) {
    if (!isNaN(value)) {
      dispatch(setSaveCircleLat(value));
    }
    if (value > 90) {
      dispatch(setSaveCircleLat(90));
    }
    if (value < -90) {
      dispatch(setSaveCircleLat(-90));
    }
    dispatch(setValueChange(true));
  }

  function handleValueCircleLon(value) {
    dispatch(setSaveCircleLon(value));
    if (value > 180) {
      dispatch(setSaveCircleLon(180));
    }
    if (value < -180) {
      dispatch(setSaveCircleLon(-180));
    }
    dispatch(setValueChange(true));
  }

  // ================classnames=====================
  const showClassname = classnames('btn-show', { 'btn-show--hide': isOpen });
  const hideClassname = classnames('btn-hide', { 'btn-hide--show': isOpen });
  const advancedSearch = classnames('advancedcontainer--hide', { 'advancedcontainer--show': isOpen });
  const networkPopup = classnames({ 'network--popup': openPopper, 'network--popup--close': !openPopper });

  // ==================controlled fields rectangle==================
  function handleValueRectangleNorth(value) {
    if (!Number.isNaN(value)) {
      dispatch(setSaveRectangleNorth(value));
    }
    if (value > 90) {
      dispatch(setSaveRectangleNorth(90));
    }
    if (value < -90) {
      dispatch(setSaveRectangleNorth(-90));
    }
    dispatch(setValueChange(true));
  }
  function handleValueRectangleSouth(value) {
    if (!Number.isNaN(value)) {
      dispatch(setSaveRectangleSouth(value));
    }
    if (value > 90) {
      dispatch(setSaveRectangleSouth(90));
    }
    if (value < -90) {
      dispatch(setSaveRectangleSouth(-90));
    }
    dispatch(setValueChange(true));
  }

  function handleValueRectangleEast(value) {
    if (!Number.isNaN(value)) {
      dispatch(setSaveRectangleEast(value));
    }
    if (value > 180) {
      dispatch(setSaveRectangleEast(180));
    }
    if (value < -180) {
      dispatch(setSaveRectangleEast(-180));
    }
    dispatch(setValueChange(true));
  }

  function handleValueRectangleWest(value) {
    if (!Number.isNaN(value)) {
      dispatch(setSaveRectangleWest(value));
    }
    if (value > 180) {
      dispatch(setSaveRectangleWest(180));
    }
    if (value < -180) {
      dispatch(setSaveRectangleWest(-180));
    }
    dispatch(setValueChange(true));
  }

  function isNumberKey(e) {
    let value = '';
    if (e.keyCode === 13) {
      console.log('value', e.target.value);
    }
    else {
      const charCode = (e.which) ? e.which : e.keyCode;
      if (charCode > 31 && (charCode !== 46 && (charCode < 48 || charCode > 57))) {
        value = false;
        return false;
      }
      value = true;
      return true;
    }
    return value;
  }

  // functions above is for construction of queries to fetch data with user selection
  function queriesConstructor(typeSelectedData, typeString) {
    let type = '';
    typeSelectedData.forEach((item) => {
      type = `${type + item},`;
    });
    type = type.substring(0, type.length - 1);
    const param = `${typeString}=`;
    const queries = param + type;
    return queries;
  }

  function routeMetadataOrFiles(MetadataOrFiles) {
    let params = '';
    if ((rectangleNorth !== '') && (rectangleSouth !== '') && (rectangleEast !== '') && (rectangleWest !== '')) {
      const param = 'coordinates=rectangle';
      params = `${params}&${param}&minLat=${rectangleSouth}&maxLat=${rectangleNorth}&minLon=${rectangleWest}&maxLon=${rectangleEast}`;
    }
    if ((circleLat !== '') && (circleLon !== '') && (radius !== '')) {
      const param = 'coordinates=circle';
      params = `${params}&${param}&centerLat=${circleLat}&centerLon=${circleLon}&radius=${radius}`;
    }
    if (polygon.length > 0) {
      const param = 'coordinates=polygon';
      let polygoncoord = '';
      let i = 0;
      while (i < polygon[0].length - 1) {
        if (MetadataOrFiles === 'Metadata') {
          polygoncoord = `${polygoncoord + polygon[0][i].lat},${polygon[0][i].lng};`;
        }
        else if (MetadataOrFiles === 'Files') {
          polygoncoord = `${polygoncoord + polygon[0][i].lat}!${polygon[0][i].lng},`;
        }
        i += 1;
      }
      polygoncoord = polygoncoord.substring(0, polygoncoord.length - 1);
      params = `${params}&${param}&polygon=${polygoncoord}`;
    }
    if (receiverTypeSelected.length >= 1) {
      const queries = queriesConstructor(receiverTypeSelected, 'receiver');
      params = `${params}&${queries}`;
    }
    if (antennaTypeSelected.length >= 1) {
      const queries = queriesConstructor(antennaTypeSelected, 'antenna');
      params = `${params}&${queries}`;
    }
    if (radomeTypeSelected.length >= 1) {
      const queries = queriesConstructor(radomeTypeSelected, 'radome');
      params = `${params}&${queries}`;
    }
    if (satelliteSystemSelected.length >= 1) {
      let satellite = '';
      satelliteSystemSelected.forEach((item) => {
        satellite = `${satellite + item.substr(0, 3)},`;
      });
      satellite = satellite.substring(0, satellite.length - 1);
      const param = 'satelliteSystem=';
      params = `${params}&${param}${satellite}`;
    }
    if ((dateFromSelected !== undefined) || (dateToSelected !== undefined)) {
      let filedate = '';
      if (dateFromSelected !== undefined) {
        if (dateFromSelected.length >= 1) {
          filedate = `${dateFromSelected},`;
        }
      }
      if (dateToSelected !== undefined) {
        if (dateToSelected.length >= 1) {
          if (filedate.substring(filedate.length - 1) === ',') {
            filedate += dateToSelected;
          }
          else {
            filedate = `${filedate},${dateToSelected}`;
          }
        }
      }
      if (filedate !== '') {
        const param = 'dateRange=';
        params = `${params}&${param}${filedate}`;
      }
    }
    if (dataAvailabilitySelected.length >= 1) {
      const param = 'dataAvailability=';
      params = `${params}&${param}${dataAvailabilitySelected}`;
    }
    if (dailyObservationSelected.length >= 1) {
      const param = 'minimumObservationYears=';
      params = `${params}&${param}${dailyObservationSelected}`;
    }
    if (fileTypeSelected.length >= 1) {
      let filetype = '';
      let samplingWindow = '';
      let samplingFrequencie = '';
      fileTypeSelected.forEach((item) => {
        const itemSplit = item.split(' - ');
        filetype = `${filetype + itemSplit[0]},`;
        samplingWindow = `${samplingWindow + itemSplit[1]},`;
        samplingFrequencie = `${samplingFrequencie + itemSplit[2]},`;
      });
      filetype = filetype.substring(0, filetype.length - 1);
      samplingWindow = samplingWindow.substring(0, samplingWindow.length - 1);
      samplingFrequencie = samplingFrequencie.substring(0, samplingFrequencie.length - 1);
      const param1 = 'fileType=';
      const param2 = 'samplingWindow=';
      const param3 = 'samplingFrequency=';
      params = `${params}&${param1}${filetype}&${param2}${samplingWindow}&${param3}${samplingFrequencie}`;
    }
    if (fileStatusSelected.length >= 1) {
      let statusfiles = '';
      fileStatusSelected.forEach((item) => {
        statusfiles = `${statusfiles + item},`;
      });
      statusfiles = statusfiles.substring(0, statusfiles.length - 1);
      const param = 'statusfile=';
      params = `${params}&${param}${statusfiles}`;
    }
    if (observationsTypeSelected.length >= 1) {
      let typofsignal = '';
      observationsTypeSelected.forEach((item) => {
        typofsignal = `${typofsignal + item},`;
      });
      typofsignal = typofsignal.substring(0, typofsignal.length - 1);

      const param = 'observationtype=';
      params = `${params}&${param}${typofsignal}`;
    }
    if (frequenciesBandSelected.length >= 1) {
      let frequency = '';
      frequenciesBandSelected.forEach((item) => {
        frequency = `${frequency + item},`;
      });
      frequency = frequency.substring(0, frequency.length - 1);

      const param = 'frequency=';
      params = `${params}&${param}${frequency}`;
    }
    if (attributeChannelSelected.length >= 1) {
      let channel = '';
      attributeChannelSelected.forEach((item) => {
        channel = `${channel + item},`;
      });
      channel = channel.substring(0, channel.length - 1);

      const param = 'channel=';
      params = `${params}&${param}${channel}`;
    }
    if (satelliteSystemSelectedQC.length >= 1) {
      let constellation = '';
      satelliteSystemSelectedQC.forEach((item) => {
        constellation = `${constellation + item.name},`;
      });
      constellation = constellation.substring(0, constellation.length - 1);

      const param = 'constellation=';
      params = `${params}&${param}${constellation}`;
    }
    if (epochSelected.length > 0) {
      const param = 'ratioepoch=';
      params = `${params}&${param}${epochSelected}`;
    }
    if (elevationSelected.length > 0) {
      const param = 'elevangle=';
      params = `${params}&${param}${elevationSelected}`;
    }
    if (multipathSelected.length > 0) {
      const param = 'multipathvalue=';
      params = `${params}&${param}${multipathSelected}`;
    }
    if (cycleSelected.length > 0) {
      const param = 'nbcycleslips=';
      params = `${params}&${param}${cycleSelected}`;
    }
    if (singlePointSelected.length > 0) {
      const param = 'spprms=';
      params = `${params}&${param}${singlePointSelected}`;
    }
    if (clockSelected.length > 0) {
      const param = 'nbclockjumps=';
      params = `${params}&${param}${clockSelected}`;
    }
    if (params !== '') {
      // 2)open the view with criteria enter
      params = params.substring(1);
      if (MetadataOrFiles === 'Metadata') {
        window.open(`${window.origin}/metadata_multiple/${params}`, '_blank');
      }
      else if (MetadataOrFiles === 'Files') {
        window.open(`${window.origin}/file/${params}`, '_blank');
      }
    }
  }

  const metadataSearch = (MetadataOrFiles) => {
    let isQuery = false;
    let link = '';
    let query = '';
    if (markerGridFilter.length > 0 && rowSelectedArray.length === 0) {
      isQuery = true;
      query = markerGridFilter;
    }
    if (markerGridFilter.length > 0 && rowSelectedArray.length === 1) {
      isQuery = false;
    }
    rowSelectedArray.forEach((el) => {
      link = `${link + el},`;
    });
    link = link.substring(0, link.length - 1);

    if ((rectangleNorth !== '') && (rectangleSouth !== '') && (rectangleEast !== '') && (rectangleWest !== '')) {
      isQuery = true;
      const param = 'coordinates=rectangle';
      query = `${query}&${param}&minLat=${rectangleSouth}&maxLat=${rectangleNorth}&minLon=${rectangleWest}&maxLon=${rectangleEast}`;
    }
    if ((circleLat !== '') && (circleLon !== '') && (radius !== '')) {
      isQuery = true;
      const param = 'coordinates=circle';
      query = `${query}&${param}&centerLat=${circleLat}&centerLon=${circleLon}&radius=${radius}`;
    }
    if (polygon.length > 0) {
      isQuery = true;
      const param = 'coordinates=polygon';
      let polygoncoord = '';
      let i = 0;
      while (i < polygon[0].length) {
        if (MetadataOrFiles === 'Metadata') {
          polygoncoord = `${polygoncoord + polygon[0][i].lat},${polygon[0][i].lng};`;
        }
        else if (MetadataOrFiles === 'Files') {
          polygoncoord = `${polygoncoord + polygon[0][i].lat}!${polygon[0][i].lng},`;
        }
        i += 1;
      }
      polygoncoord = polygoncoord.substring(0, polygoncoord.length - 1);
      query = `${query}&${param}&polygon=${polygoncoord}`;
    }

    if (receiverTypeSelected.length >= 1 && receiverTypeSelected[0] !== '') {
      isQuery = true;
      const queries = queriesConstructor(receiverTypeSelected, 'receiver');
      query = `${query}&${queries}`;
    }
    if (antennaTypeSelected.length >= 1 && antennaTypeSelected[0] !== '') {
      isQuery = true;
      const queries = queriesConstructor(antennaTypeSelected, 'antenna');
      query = `${query}&${queries}`;
    }
    if (radomeTypeSelected.length >= 1 && radomeTypeSelected[0] !== '') {
      isQuery = true;
      const queries = queriesConstructor(radomeTypeSelected, 'radome');
      query = `${query}&${queries}`;
    }
    if (satelliteSystemSelected.length >= 1 && satelliteSystemSelected[0] !== '') {
      isQuery = true;
      let satellite = '';
      satelliteSystemSelected.forEach((item) => {
        satellite = `${satellite + item.substr(0, 3)},`;
      });
      satellite = satellite.substring(0, satellite.length - 1);
      const param = 'satelliteSystem=';
      query = `${query}&${param}${satellite}`;
    }
    if ((dateFromSelected !== undefined) && (dateToSelected !== undefined)) {
      let filedate = '';
      if (dateFromSelected !== undefined) {
        if (dateFromSelected.length >= 1) {
          filedate = `${dateFromSelected},`;
        }
      }
      if (dateToSelected !== undefined) {
        if (dateToSelected.length >= 1) {
          if (filedate.substring(filedate.length - 1) === ',') {
            filedate += dateToSelected;
          }
          else {
            filedate = `${filedate},${dateToSelected}`;
          }
        }
      }
      if (filedate !== '') {
        isQuery = true;
        const param = 'dateRange=';
        query = `${query}&${param}${filedate}`;
      }
    }
    if (dataAvailabilitySelected.length >= 1) {
      isQuery = true;
      const param = 'dataAvailability=';
      query = `${query}&${param}${dataAvailabilitySelected}`;
    }
    if (dailyObservationSelected.length >= 1) {
      isQuery = true;
      const param = 'minimumObservationYears=';
      query = `${query}&${param}${dailyObservationSelected}`;
    }
    if (fileTypeSelected.length >= 1 && fileTypeSelected[0] !== '') {
      isQuery = true;
      let filetype = '';
      let samplingWindow = '';
      let samplingFrequencie = '';
      fileTypeSelected.forEach((item) => {
        const itemSplit = item.split(' - ');
        filetype = `${filetype + itemSplit[0]},`;
        samplingWindow = `${samplingWindow + itemSplit[1]},`;
        samplingFrequencie = `${samplingFrequencie + itemSplit[2]},`;
      });
      filetype = filetype.substring(0, filetype.length - 1);
      samplingWindow = samplingWindow.substring(0, samplingWindow.length - 1);
      samplingFrequencie = samplingFrequencie.substring(0, samplingFrequencie.length - 1);
      const param1 = 'fileType=';
      const param2 = 'samplingWindow=';
      const param3 = 'samplingFrequency=';
      query = `${query}&${param1}${filetype}&${param2}${samplingWindow}&${param3}${samplingFrequencie}`;
    }
    if (fileStatusSelected.length >= 1 && fileStatusSelected[0] !== 0) {
      isQuery = true;
      let statusfiles = '';
      fileStatusSelected.forEach((item) => {
        statusfiles = `${statusfiles + item},`;
      });
      statusfiles = statusfiles.substring(0, statusfiles.length - 1);
      const param = 'statusfile=';
      query = `${query}&${param}${statusfiles}`;
    }
    if (observationsTypeSelected.length >= 1 && observationsTypeSelected[0] !== '') {
      isQuery = true;
      let typofsignal = '';
      observationsTypeSelected.forEach((item) => {
        typofsignal = `${typofsignal + item},`;
      });
      typofsignal = typofsignal.substring(0, typofsignal.length - 1);
      const param = 'observationtype=';
      query = `${query}&${param}${typofsignal}`;
    }
    if (frequenciesBandSelected.length >= 1 && frequenciesBandSelected[0] !== '') {
      isQuery = true;
      let frequency = '';
      frequenciesBandSelected.forEach((item) => {
        frequency = `${frequency + item},`;
      });
      frequency = frequency.substring(0, frequency.length - 1);
      const param = 'frequency=';
      query = `${query}&${param}${frequency}`;
    }
    if (attributeChannelSelected.length >= 1 && frequenciesBandSelected[0] !== '') {
      isQuery = true;
      let channel = '';
      attributeChannelSelected.forEach((item) => {
        channel = `${channel + item},`;
      });
      channel = channel.substring(0, channel.length - 1);
      const param = 'channel=';
      query = `${query}&${param}${channel}`;
    }
    if (satelliteSystemSelectedQC.length >= 1 && satelliteSystemSelectedQC[0] !== '') {
      isQuery = true;
      let constellation = '';
      satelliteSystemSelectedQC.forEach((item) => {
        constellation = `${constellation + item.name},`;
      });
      constellation = constellation.substring(0, constellation.length - 1);
      const param = 'constellation=';
      query = `${query}&${param}${constellation}`;
    }
    if (epochSelected.length > 0) {
      isQuery = true;
      const param = 'ratioepoch=';
      query = `${query}&${param}${epochSelected}`;
    }
    if (elevationSelected.length > 0) {
      isQuery = true;
      const param = 'elevangle=';
      query = `${query}&${param}${elevationSelected}`;
    }
    if (multipathSelected.length > 0) {
      isQuery = true;
      const param = 'multipathvalue=';
      query = `${query}&${param}${multipathSelected}`;
    }
    if (cycleSelected.length > 0) {
      isQuery = true;
      const param = 'nbcycleslips=';
      query = `${query}&${param}${cycleSelected}`;
    }
    if (singlePointSelected.length > 0) {
      isQuery = true;
      const param = 'spprms=';
      query = `${query}&${param}${singlePointSelected}`;
    }
    if (clockSelected.length > 0) {
      isQuery = true;
      const param = 'nbclockjumps=';
      query = `${query}&${param}${clockSelected}`;
    }
    if (siteNameGridFilter.length > 0) {
      isQuery = true;
      const param = 'site=';
      query = `${query}&${param}${siteNameGridFilter}`;
    }
    if ((greaterLatGridFilter.toString().length > 0 && typeof greaterLatGridFilter === 'number') || (lessLatGridFilter.toString().length > 0 && typeof lessLatGridFilter === 'number')) {
      isQuery = true;
      let latitudes = '';
      if ((greaterLatGridFilter.toString().length > 0 && typeof greaterLatGridFilter === 'number')) {
        latitudes = greaterLatGridFilter;
      }
      if ((lessLatGridFilter.toString().length > 0 && typeof lessLatGridFilter === 'number')) {
        latitudes = `${latitudes},${lessLatGridFilter}`;
      }
      if (latitudes !== '') {
        const param = 'latitude=';
        query = `${query}&${param}${latitudes}`;
      }
    }
    if ((greaterLonGridFilter.toString().length > 0 && typeof greaterLonGridFilter === 'number') || (lessLonGridFilter.toString().length > 0 && typeof lessLonGridFilter === 'number')) {
      isQuery = true;
      let longitudes = '';
      if ((greaterLonGridFilter.toString().length > 0 && typeof greaterLonGridFilter === 'number')) {
        longitudes = greaterLonGridFilter;
      }
      if ((lessLonGridFilter.toString().length > 0 && typeof lessLonGridFilter === 'number')) {
        longitudes = `${longitudes},${lessLonGridFilter}`;
      }
      if (longitudes !== '') {
        const param = 'longitude=';
        query = `${query}&${param}${longitudes}`;
      }
    }
    if ((greaterAltGridFilter.toString().length > 0 && typeof greaterAltGridFilter === 'number') || (lessAltGridFilter.toString().length > 0 && typeof lessAltGridFilter === 'number')) {
      isQuery = true;
      let altitudes = '';
      if ((greaterAltGridFilter.toString().length > 0 && typeof greaterAltGridFilter === 'number')) {
        altitudes = greaterAltGridFilter;
      }
      if ((lessAltGridFilter.toString().length > 0 && typeof lessAltGridFilter === 'number')) {
        altitudes = `${altitudes},${lessAltGridFilter}`;
      }
      if (altitudes !== '') {
        const param = 'altitude=';
        query = `${query}&${param}${altitudes}`;
      }
    }
    if (greaterInstallDateGridFiletr.length > 0) {
      isQuery = true;
      const param = 'installedDateMin=';
      query = `${query}&${param}${greaterInstallDateGridFiletr}`;
    }
    if (lessInstallDateGridFilter.length > 0) {
      isQuery = true;
      const param = 'installedDateMax=';
      query = `${query}&${param}${lessInstallDateGridFilter}`;
    }
    if (greaterEndDateGridFilter.length > 0) {
      const param = 'removedDateMin=';
      query = `${query}&${param}${greaterEndDateGridFilter}`;
    }
    if (lessEndDateGridFilter.length > 0) {
      isQuery = true;
      const param = 'removedDateMax=';
      query = `${query}&${param}${lessEndDateGridFilter}`;
    }
    if (countryGridFilterQuery.length > 0) {
      isQuery = true;
      const param = 'country=';
      query = `${query}&${param}${countryGridFilterQuery}`;
    }
    if (stateGridFilter.length > 0) {
      isQuery = true;
      const param = 'state=';
      query = `${query}&${param}${encodeURIComponent(stateGridFilter)}`;
    }
    if (cityGridFilter.length > 0) {
      isQuery = true;
      const param = 'city=';
      query = `${query}&${param}${encodeURIComponent(cityGridFilter)}`;
    }
    if (agencyGridFilter.length > 0) {
      isQuery = true;
      const param = 'agency=';
      query = `${query}&${param}${encodeURIComponent(agencyGridFilter)}`;
    }
    if (networkGridFilter.length > 0) {
      isQuery = true;
      const param = 'network=';
      query = `${query}&${param}${encodeURIComponent(networkGridFilter)}`;
    }
    if (invertedNetworkGridFilter.length > 0) {
      isQuery = true;
      const param = 'invertedNetworks=';
      query = `${query}&${param}${encodeURIComponent(invertedNetworkGridFilter)}`;
    }

    // if (query.length > 0) {
    //   query = encodeURIComponent(query);
    // }
    if (rowSelectedArray.length !== 0 && rowSelectedArray.length === 1 && MetadataOrFiles === 'Metadata' && isQuery === false) {
      window.open(`${window.location.origin}${window.location.pathname}#/metadata/marker=${rowSelectedArray[0]}/description`, '_blank');
    }
    else if (rowSelectedArray.length !== 0 && rowSelectedArray.length === 1 && MetadataOrFiles === 'Files' && isQuery === false) {
      window.open(`${window.location.origin}${window.location.pathname}#/file/marker=${rowSelectedArray[0]}`, '_blank');
    }
    else if (rowSelectedArray.length !== 0 && rowSelectedArray.length > 1 && MetadataOrFiles === 'Metadata' && isQuery === false) {
      window.open(`${window.location.origin}${window.location.pathname}#/metadata_multiple/marker=${link}`, '_blank');
    }
    else if (rowSelectedArray.length !== 0 && rowSelectedArray.length > 1 && MetadataOrFiles === 'Files' && isQuery === false) {
      window.open(`${window.location.origin}${window.location.pathname}#/file/marker=${link}`, '_blank');
    }
    else if (rowSelectedArray.length !== 0 && rowSelectedArray.length > 1 && MetadataOrFiles === 'Metadata' && isQuery === true) {
      window.open(`${window.location.origin}${window.location.pathname}#/metadata_multiple/marker=${link}${query}`, '_blank');
    }
    else if (rowSelectedArray.length !== 0 && rowSelectedArray.length > 1 && MetadataOrFiles === 'Files' && isQuery === true) {
      window.open(`${window.location.origin}${window.location.pathname}#/file/marker=${link}${query}`, '_blank');
    }
    else if (rowSelectedArray.length !== 0 && rowSelectedArray.length === 1 && MetadataOrFiles === 'Files' && isQuery === true) {
      window.open(`${window.location.origin}${window.location.pathname}#/file/marker=${rowSelectedArray[0]}${query}`, '_blank');
    }
    else if (rowSelectedArray.length !== 0 && rowSelectedArray.length === 1 && MetadataOrFiles === 'Metadata' && isQuery === true) {
      window.open(`${window.location.origin}${window.location.pathname}#/metadata_multiple/marker=${rowSelectedArray[0]}${query}`, '_blank');
    }
    else if (rowSelectedArray.length === 0 && MetadataOrFiles === 'Metadata' && isQuery === true && markerGridFilter.length > 0) {
      window.open(`${window.location.origin}${window.location.pathname}#/metadata_multiple/marker=${query}`, '_blank');
    }
    else if (rowSelectedArray.length === 0 && MetadataOrFiles === 'Files' && isQuery === true && markerGridFilter.length > 0) {
      window.open(`${window.location.origin}${window.location.pathname}#/file/marker=${query}`, '_blank');
    }
    else if (rowSelectedArray.length === 0 && MetadataOrFiles === 'Metadata' && isQuery === true) {
      window.open(`${window.location.origin}${window.location.pathname}#/metadata_multiple/${query}`, '_blank');
    }
    else if (rowSelectedArray.length === 0 && MetadataOrFiles === 'Files' && isQuery === true) {
      window.open(`${window.location.origin}${window.location.pathname}#/file/${query}`, '_blank');
    }
    else if (rowSelectedArray.length === 0 && markerGridFilter.length === 0) {
      dispatch(setFileNoData(true));
    }
    // else if (rowSelectedArray.length === 0 && MetadataOrFiles === 'Metadata' && isQuery === true && markerGridFilter.length !== 0) {
    //   window.open(`${window.location.origin}${window.location.pathname}#/metadata_multiple/marker=${query}`, '_blank');
    // }
    // else if (rowSelectedArray.length === 0 && MetadataOrFiles === 'Metadata' && isQuery === true && markerGridFilter.length === 0) {
    //   query = query.substring(1);
    //   window.open(`${window.location.origin}${window.location.pathname}#/metadata_multiple/${query}`, '_blank');
    // }
    // else if (rowSelectedArray.length === 0 && MetadataOrFiles === 'Files' && isQuery === true) {
    //   window.open(`${window.location.origin}${window.location.pathname}#/file/${query}`, '_blank');
    // }
    else {
      routeMetadataOrFiles(MetadataOrFiles);
    }
  };

  const handleJoyrideCallback = (data) => {
    const { status } = data;
    const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

    if (finishedStatuses.includes(status)) {
      dispatch(setOpenTour(false));
    }
  };

  function handleClearButton() {
    dispatch(setClearButton(true));
  }

  function handleExportCsv() {
    dispatch(exportCsv(true));
  }

  return (
    <section>
      <Joyride
        run={openTour}
        steps={steps}
        callback={handleJoyrideCallback}
        continuous
        hideCloseButton
        scrollToFirstStep
        showProgress
        showSkipButton
        styles={{
          options: {
            zIndex: 10000,
            primaryColor: '#048b9a',
          },
        }}
      />
      <div className="container">
        {/* SITE */}
        {(loadingMap || loadingHeader || loadingFooter) && <Spinner2 />}
        {(!loadingMap && !loadingHeader && !loadingFooter && newList !== undefined) && (
        <>
          <div id="site">
            <div id="buttonconteneur">
              <nav className="navbar navbar-expand-lg">
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo02bis" aria-controls="navbarTogglerDemo02bis" aria-expanded="false" aria-label="Toggle navigation">
                  <span className="navbar-toggler-icon" />
                </button>
                <div className="collapse navbar-collapse" id="navbarTogglerDemo02bis">
                  <div>
                    <button type="button" className="btn btn-metadata" aria-label="view" id="runsearch" title="This button allows to launch the search of metadata" onClick={() => metadataSearch('Metadata')}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-eye" viewBox="0 0 16 16">
                        <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                        <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                      </svg> Metadata Search
                    </button>
                  </div>
                  <div>
                    <button type="button" className="btn btn-download" aria-label="file search" id="filesearch" title="This button allows to launch the search of files" onClick={() => metadataSearch('Files')}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-file-earmark-richtext" viewBox="0 0 16 16">
                        <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z" />
                        <path d="M4.5 12.5A.5.5 0 0 1 5 12h3a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-2A.5.5 0 0 1 5 10h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm1.639-3.708 1.33.886 1.854-1.855a.25.25 0 0 1 .289-.047l1.888.974V8.5a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5V8s1.54-1.274 1.639-1.208zM6.25 6a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5z" />
                      </svg> Files Search / Download
                    </button>
                  </div>
                  <div>
                    <button
                      type="button"
                      className="btn btn-clear"
                      aria-label="refresh"
                      id="clear"
                      title="This button allows to clear all what you selected"
                      onClick={handleClearButton}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-eraser" viewBox="0 0 16 16">
                        <path d="M8.086 2.207a2 2 0 0 1 2.828 0l3.879 3.879a2 2 0 0 1 0 2.828l-5.5 5.5A2 2 0 0 1 7.879 15H5.12a2 2 0 0 1-1.414-.586l-2.5-2.5a2 2 0 0 1 0-2.828l6.879-6.879zm2.121.707a1 1 0 0 0-1.414 0L4.16 7.547l5.293 5.293 4.633-4.633a1 1 0 0 0 0-1.414l-3.879-3.879zM8.746 13.547 3.453 8.254 1.914 9.793a1 1 0 0 0 0 1.414l2.5 2.5a1 1 0 0 0 .707.293H7.88a1 1 0 0 0 .707-.293l.16-.16z" />
                      </svg> Clear
                    </button>
                  </div>
                  <div id="advancedsearch">
                    <button
                      type="button"
                      className={`btn btn-show ${showClassname}`}
                      onClick={handleToggleClick}
                    >
                      Show advanced search
                    </button>
                    <button
                      type="button"
                      className={`btn btn-hide ${hideClassname}`}
                      onClick={handleToggleClick}
                      aria-label="simple"
                      title="This button allows to show and hide more advanced parameters"
                    >
                      Hide advanced search
                    </button>
                  </div>
                  <div className="exportButton--container">
                    <button type="button" onClick={handleExportCsv} className="button--exportCSV">Export table as CSV</button>
                  </div>
                </div>
              </nav>
            </div>
            {/* <Suspense fallback={<Spinner4/>}> */}
            <div id="mapconteneur">
              <div id="latlon">
                <p id="latlon__title">
                  Spatial selection
                </p>
                <p className="latlon__paragraph">
                  Rectangle
                </p>
                <p className="latlon__paragraph--rectangle">Lat-Lon Bounding Box</p>
                <table className="latlon__table">
                  <tbody>
                    <tr>
                      <td />
                      <td>
                        <input type="text" size="8" title="North" placeholder="North" min={-90} max={90} value={rectangleNorth} onKeyDown={(e) => isNumberKey(e)} onChange={(e) => handleValueRectangleNorth(e.target.value)} />
                      </td>
                      <td />
                    </tr>
                  </tbody>
                </table>
                <table className="latlon__table">
                  <tbody>
                    <tr>
                      <td>
                        <input className="latlon__table--input" type="text" size="8" title="West" placeholder="West" min={-180} max={180} value={rectangleWest} onKeyDown={(e) => isNumberKey(e)} onChange={(e) => handleValueRectangleWest(e.target.value)} />
                      </td>
                      <td />
                      <td>
                        <input type="text" size="8" title="East" placeholder="East" min={-180} max={180} value={rectangleEast} onKeyDown={(e) => isNumberKey(e)} onChange={(e) => handleValueRectangleEast(e.target.value)} />
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table className="latlon__table">
                  <tbody>
                    <tr>
                      <td />
                      <td>
                        <input type="text" size="8" title="South" placeholder="South" min={-90} max={90} value={rectangleSouth} onKeyDown={(e) => isNumberKey(e)} onChange={(e) => handleValueRectangleSouth(e.target.value)} />
                      </td>
                      <td />
                    </tr>
                  </tbody>
                </table>
                <hr />
                <p className="latlon__paragraph">
                  Circle
                </p>
                <table className="latlon__table">
                  <tbody>
                    <tr>
                      <td>Latitude</td>
                      <td>Longitude</td>
                    </tr>
                    <tr>
                      <td>
                        <input className="latlon__table--input" type="text" size="8" title="latitude" min={-90} max={90} onKeyDown={(e) => isNumberKey(e)} value={circleLat} onChange={(e) => handleValueCircleLat(e.target.value)} />
                      </td>
                      <td>
                        <input type="text" size="8" title="longitude" min={-180} max={180} onKeyDown={(e) => isNumberKey(e)} value={circleLon} onChange={(e) => handleValueCircleLon(e.target.value)} />
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table className="latlon__table">
                  <tbody>
                    <tr>
                      <td />
                      <td>Radius (Km)</td>
                      <td />
                    </tr>
                    <tr>
                      <td />
                      <td>
                        <input
                          value={radius}
                          type="text"
                          size="8"
                          title="Radius of circle (km), if center is empty enter one"
                          id="inputDistance"
                          onChange={handleRadiusValue}
                        />
                      </td>
                      <td />
                    </tr>
                  </tbody>
                </table>
                <SliderRadius radius={radius} />
              </div>
              <div id="mapid">
                {/* <Suspense fallback={<Spinner4/>}> */}
                  <MapLeaflet />
                {/* </Suspense> */}
              </div>
              <div className={`advancedcontainer ${advancedSearch}`}>
                {/* <Suspense fallback={<Spinner4/>}> */}
                  <AdvancedSearch />
                {/* </Suspense> */}
              </div>
            </div>
            <div className="dataGridContainer">
              {/* <Suspense fallback={<Spinner4/>}> */}
                <DataGrid />
              {/* </Suspense> */}
            </div>
            {/* </Suspense> */}
            {(!dataAvailable) && <NoApiResponse />}
          </div>
          <br />
        </>
        )}
        {/* /SITE */}
        {(!dataAvailable && newList === undefined) && <NoApiResponse />}
      </div>
      <div className={networkPopup}>
        <div>
          <Button type="button" className="network--button" onClick={handleCloseNetworkPopup}>X</Button>
        </div>
        <p>Station : {networkNameStation}</p>
        <p>
          Network : | {networkClicked.map((netw) => <Link to={`network/name=${netw}`} target="_blank" key={netw} className="network--popup--link">{netw} | </Link>)}
        </p>
      </div>
      <ModalFileNoData />
    </section>
  );
}
export default Site;
